// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__aCH44","container":"styles_container__dO2WR","title":"styles_title__IEtR8","wrapper":"styles_wrapper__2k7jt","answer":"styles_answer__2Rp6E"};